var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3560 2508)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "translate(3560 -2508)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3564.982 -2503.03)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.32,635.265a3.2,3.2,0,0,1-.933,2.182q-8.2,8.208-16.427,16.4a4.117,4.117,0,0,1-1.825.944c-1.864.476-3.756.84-5.637,1.25-.971.212-1.377-.2-1.156-1.175.436-1.922.824-3.858,1.337-5.76a4.339,4.339,0,0,1,1.036-1.852q8-8.081,16.059-16.1a3.159,3.159,0,0,1,4.719-.12c.668.613,1.3,1.271,1.92,1.93A3.228,3.228,0,0,1,185.32,635.265ZM161.054,654.32c1.586-.332,3-.65,4.418-.914a3.52,3.52,0,0,0,1.913-1.069q5.8-5.845,11.642-11.658c.187-.188.361-.389.428-.461l-4.371-4.424a3.349,3.349,0,0,1-.391.577c-3.636,3.648-7.25,7.32-10.942,10.911a6.086,6.086,0,0,0-1.956,3.594C161.631,651.986,161.328,653.075,161.054,654.32ZM176.511,634.5l4.23,4.243c.866-.819,1.856-1.65,2.713-2.6a1.526,1.526,0,0,0-.186-2.157c-.568-.615-1.166-1.2-1.772-1.783a1.744,1.744,0,0,0-2.648.023C178.064,632.973,177.29,633.737,176.511,634.5Z",
    transform: "translate(-159.283 -630.033)",
    fill: "currentColor",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.61fc627f.svg";
export { ForwardRef as ReactComponent };